<div class="content-wrapper">
    <div class="content-body">
        <section id="lectures">
            <div class="row">
                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12">
                    <h2 class="mt-5px">Lectures</h2>
                </div>
                <div class="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-xs-12">
                    <button class="btn btn-primary pull-right color-white color-white users-btn mr-2"
                            (click)="showSearch = !showSearch">
                        <i aria-hidden="true" class="fa fa-search mr-8px"></i>&nbsp;Search
                    </button>
                    <button class="btn btn-primary pull-right color-white color-white users-btn mr-2 cursor-pointer"
                            (click)="add()">
                        <i aria-hidden="true" class="fa fa-plus-circle mr-8px"></i>&nbsp;Add Lecture
                    </button>
                </div>
            </div>
            <div class="row search-card mt-3" *ngIf="showSearch">
                <div class="col-12">
                    <form class="form mt-2 mb--8px" novalidate [formGroup]="searchForm">
                        <div class="row">
                            <div class="col-md-4 col-lg-4 col-sm-4 col-xs-12">
                                <fieldset class="form-group">
                                    <input class="form-control" type="text" formControlName="name" placeholder="Name">
                                </fieldset>
                            </div>
                            <div class="col-md-4 col-lg-4 col-sm-4 col-xs-12">
                                <fieldset class="form-group">
                                    <select class="form-control" formControlName="category_id">
                                        <option value="">Select Category</option>
                                        <option *ngFor="let cat of categories" [value]="cat.id">
                                            {{ cat.name }}
                                        </option>
                                    </select>
                                </fieldset>
                            </div>
                            <div class="col-md-4 col-lg-4 col-sm-4 col-xs-12">
                                <fieldset class="form-group">
                                    <select class="form-control" formControlName="university_id">
                                        <option value="">Select University</option>
                                        <option *ngFor="let uni of universities" [value]="uni.id">
                                            {{ uni.name }}
                                        </option>
                                    </select>
                                </fieldset>
                            </div>
                            <div class="col-md-4 col-lg-4 col-sm-4 col-xs-12">
                                <fieldset class="form-group">
                                    <select class="form-control" formControlName="course_id">
                                        <option value="">Select Course</option>
                                        <option *ngFor="let course of coursesList" [value]="course.id">
                                            {{ course.name }}
                                        </option>
                                    </select>
                                </fieldset>
                            </div>
                            <div class="col-md-4 col-lg-4 col-sm-4 col-xs-12">
                                <fieldset class="form-group">
                                    <select class="form-control" formControlName="semester">
                                        <option value="">Select Semester</option>
                                        <option *ngFor="let sem of semesters" [value]="sem">{{ sem }}</option>
                                    </select>
                                </fieldset>
                            </div>
                            <div class="col-md-4 col-lg-4 col-sm-4 col-xs-12 text-center">
                                <button class="btn btn-primary btn-block btn-raised color-white mr-2 users-btn"
                                        (click)="search()"
                                        [disabled]="submitting">
                                    <i class="fas fa-spinner fa-pulse mr-1" *ngIf="submitting"></i>Search
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="row d-none d-md-block mt-3">
                <div class="col-12">
                    <div class="card">
                        <div class="container-fluid">
                            <div class="row d-none d-md-block overflow-x-scroll overflow-table">
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <table class="table table-list">
                                        <thead>
                                        <tr>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">S.No</h6></th>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Category</h6></th>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Name</h6></th>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Video</h6></th>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Action</h6></th>
                                        </tr>
                                        </thead>
                                        <tbody *ngIf="lectures && lectures.length > 0; else noDataToShowWeb">
                                        <tr *ngFor="let lecture of lectures; let i = index">
                                            <td class="text-center">
                                                <h6 class="mt-1">{{(pagination.page - 1) * (pagination.perpage ? pagination.perpage : 0) + i + 1}}
                                                    .</h6>
                                            </td>
                                            <td class="text-center"><h6 class="mt-1">{{lecture?.categories?.name}}</h6></td>
                                            <td class="text-center"><h6 class="mt-1">{{lecture?.name}}</h6></td>
                                            <td class="text-center">
                                                <ng-container *ngIf="lecture?.video_file_data?.url; else noFile">
                                                    <a [href]="lecture.video_file_data.url"
                                                       target="_blank"
                                                       rel="noopener noreferrer"
                                                       class="btn btn-sm btn-outline-primary">
                                                        <i class="fas fa-eye mr-1"></i> View
                                                    </a>
                                                </ng-container>
                                                <ng-template #noFile>
                                                    <span class="text-muted">—</span>
                                                </ng-template>
                                            </td>
                                            <td class="text-center">
                                                <i aria-hidden="true"
                                                   class="fas fa-edit f_20 ml-5px text-info cursor-pointer font-weight-light mt-1"
                                                   title="Edit" (click)="edit(lecture)"></i>
                                                <i aria-hidden="true"
                                                   class="fas fa-lock f_20 ml-5px text-danger cursor-pointer mt-1"
                                                   title="In Active" *ngIf="lecture?.status === 'ACTIVE'"
                                                   (click)="updateStatus('INACTIVE', lecture)"></i>
                                                <i aria-hidden="true"
                                                   class="fas fa-lock-open f_20 ml-5px text-success cursor-pointer mt-1"
                                                   title="Active" *ngIf="lecture?.status === 'INACTIVE'"
                                                   (click)="updateStatus('ACTIVE', lecture)"></i>
                                            </td>
                                        </tr>
                                        </tbody>
                                        <ng-template #noDataToShowWeb>
                                            <tbody>
                                            <tr>
                                                <td colspan="7" class="text-center"><h6>No data to show</h6></td>
                                            </tr>
                                            </tbody>
                                        </ng-template>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row pagination-table">
                <ngb-pagination (pageChange)="onPageChange($event)"
                                [(page)]="pagination.page"
                                [boundaryLinks]="true"
                                [collectionSize]="pagination.total"
                                [maxSize]="5"
                                [pageSize]="pagination.perpage">
                </ngb-pagination>
            </div>
        </section>
    </div>
    <core-sidebar
            class="modal modal-slide-in sidebar-todo-modal fade"
            name="add-lecture"
            overlayClass="modal-backdrop">
        <app-add-lecture [data]="data" (valueSubmitted)="getData($event)"></app-add-lecture>
    </core-sidebar>

</div>
